import React, { useEffect, useMemo } from "react";
import CustomReactTable from "../../../components/ReactTable/CustomReactTable";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  getAllOffers,
  patchEditOfferFormValues,
} from "../../../redux/CarsManagement/Offers/offersSlice";
import { getFormattedDate } from "../../../helpers/DateHelper";

function OffersGrid() {
  const dispatch = useDispatch();
  const { allOffers, isLoading, addOrEditResult } = useSelector(
    (state) => state.offers
  );

  // Patch Car info
  const handleEditOffer = (row) => {
    dispatch(patchEditOfferFormValues(row));
  };

  // Get All Offers
  useEffect(() => {
    dispatch(getAllOffers());
  }, [addOrEditResult]);

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "عنوان العرض",
        accessor: "nameAr",
      },
      {
        Header: "بداية العرض",
        accessor: "offer_start",
        Cell: ({ row }) => getFormattedDate(row.original.offer_start),
      },
      {
        Header: "نهاية العرض",
        accessor: "offer_end",
        Cell: ({ row }) => getFormattedDate(row.original.offer_end),
      },
      {
        Header: "السعر قبل",
        accessor: "price_before",
      },
      {
        Header: "السعر بعد",
        accessor: "price_after",
      },
      {
        Header: "نسبة الخصم",
        accessor: "offer_discount",
      },
      {
        Header: "الترتيب",
        accessor: "order",
      },
      {
        Header: "الحالة",
        accessor: "status",
        Cell: ({ row }) =>
          row.original.status ? (
            <span className="uk-text-success" uk-icon="check"></span>
          ) : (
            <span className="uk-text-danger" uk-icon="close"></span>
          ),
      },
      {
        Header: "الإجراء",
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="actions uk-flex uk-flex-center uk-flex-middle">
            <NavLink
              to="/Offers/EditOffer"
              uk-tooltip="تعديل"
              className="uk-icon-button"
              uk-icon="pencil"
              onClick={() => handleEditOffer(row.original)}
            ></NavLink>
            <button
              uk-tooltip="حذف"
              className="uk-icon-button uk-margin-small-right"
              uk-icon="trash"
            ></button>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <CustomReactTable
      data={allOffers}
      columns={columns}
      isLoading={isLoading}
    />
  );
}

export default OffersGrid;
